module.exports = __webpack_public_path__ + "static/media/communicator_faq@2x.e6857efe.png";